/* global your_ajax_object */
class GetDataForGus {
  buttonID = "get_data_for_gus";
  nipID = "billing_nip";
  nipErrorClass = "js-billing_nip--error";

  fieldsID = [
    "billing_company",
//        "reg_email",
//        "billing_phone",
    "billing_address_1",
    "billing_postcode",
    "billing_city"
  ];

  constructor() {
    this.button = document.querySelector( `#${ this.buttonID }` );
    this.input = document.querySelector( `#${ this.nipID }` );
    this.nipError = document.querySelector( `.${ this.nipErrorClass }` );

    if ( this.button && this.input ) {
      this.event();
    }
  }

  event() {
    this.button.addEventListener( "click", () => this.handleClick() );
  }

  handleClick() {
    this.errorParagraph = document.querySelector( '#errorParagraph' );
    if ( this.input.value.length === 10 ) {
      if ( this.errorParagraph ) {
        this.errorParagraph.remove();
      }
      this.fetchData();
    }
    else {
      this.showError( "Podaj poprawny NIP" );
    }
  }

  showError( content ) {
    if ( !this.errorParagraph ) {
      this.nipError.textContent = content;
    }
  }

  fetchData() {

    const data = {};

    fetch( your_ajax_object.ajax_url, {
      method:  'POST',
      body:    new URLSearchParams( {
        'action': 'get_company_data',
        'nonce':  your_ajax_object.nonce,
        'nip':    document.querySelector( "#billing_nip" ).value
      } ),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    } )
      .then( response => response.json() )
      .then( data => {
        if ( data.success && data.data && data.data.company ) {
          this.setData( data.data.company );
          this.showError( "" );
        }
        else {
          this.showError( "Nie znaleziono firmy" );
        }
      } )
      .catch( ( error ) => console.error( 'Error:', error ) );
  }

  setData( company ) {
    this.fieldsID.forEach( ( field, key ) => {
      const input = document.querySelector( `#${ field }` );
      input.value = company[field];
    } );
  }
}

export default GetDataForGus;
